import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  addCreator,
  addCreatorCommission,
} from '../../services/creatorServices';
import BasicInfoEdit from './BasicInfo/BasicInfoEdit';
import {
  DEFAULT_SENDER_EMAIL,
  DEFAULT_COMMISSION_TYPE,
  DEFAULT_EFFECTIVE_FROM_VALUE,
} from './BasicInfo/utilities';

function CreatorAdd(props) {
  const { isOpen, toggle } = props;

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'On Idle Mode!',
  });

  const [commissionPerc, setCommissionPerc] = useState(50); //This value gets updated in the form itself.

  const [initialValues, setInitialValues] = useState({
    firstName: '',
    lastName: '',
    description: '',
    longDescription: '',
    countryId: '',
    trainerExists: true,
    commissionPercentage: 50,
    senderEmail: 'hello@nasacademy.com',
    updateTo: [{ name: 'Aditya', email: 'aditya@nasdaily.com' }],
  });

  const formatData = (values) => {
    let updateToNames = [];
    let updateToMails = [];
    values.updateTo.forEach((item) => {
      updateToNames.push(item.name);
      updateToMails.push(item.email);
    });
    let creatorValue = {
      firstName: values.firstName,
      lastName: values.lastName,
      university: values.university,
      email: values.email,
      senderEmail: values.senderEmail
        ? values.senderEmail
        : DEFAULT_SENDER_EMAIL,
      trainers: values.trainerId ? [values.trainerId] : [],
      updateToNames,
      updateToMails,
      academyName: values.academyName,
      fbAcademyLink: values.fbAcademyLink,
      bannerImgData: values.bannerImgData,
      thumbnailImgData: values.thumbnailImgData,
    };

    let creatorCommissionValue = {
      university: values.university,
      type: DEFAULT_COMMISSION_TYPE,
      value: commissionPerc,
      coursesApplicable: values.coursesApplicable,
      courseOffersApplicable: values.courseOffersApplicable,
      effectiveFrom: DEFAULT_EFFECTIVE_FROM_VALUE,
      effectiveTo: null,
    };

    return { creatorValue, creatorCommissionValue };
  };

  async function onSubmit(values) {
    const data = formatData(values);
    setStatus({ type: 'LOADING', message: 'Loading data!' });
    await addCreator(data.creatorValue)
      .then((response) => {
        setStatus({ type: 'SUCCESS', message: 'Successfully added creator!' });
      })
      .catch((err) => {
        console.log('Error getting data from the admin backend:', err);
        alert('Getting data from the backend failed!');
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
    await addCreatorCommission(data.creatorCommissionValue)
      .then((response) => {
        setStatus({ type: 'SUCCESS', message: 'Successfully added creator!' });
      })
      .catch((err) => {
        console.log('Error getting data from the admin backend:', err);
        alert('Getting data from the backend failed!');
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  return (
    <BasicInfoEdit
      type="ADD"
      isOpen={isOpen}
      toggle={toggle}
      initialValues={initialValues}
      onSubmit={onSubmit}
      setCommissionPerc={setCommissionPerc}
      commissionPerc={commissionPerc}
      status={status}
    />
  );
}

export default CreatorAdd;
